
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BroadcastMessageService {
  url: any = environment.API_URL;


  constructor(
    private http: HttpClient

  ) { }

  
getBroadCast(data: any) {
  return this.http.get(this.url + 'admin/list?type=dashboard', data);
}

getmessageBySearch(data:any){
  return this.http.post(this.url + 'admin/searchUser', data);
}

getMessageList(data:any) {
  return this.http.post(this.url + 'admin/sendMessageToUser', data);
}
}
